import { Box, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import AccessLevelTab from '../components/access-levels/AccessLevelTab'
import { useBreakpoint } from '../hooks/useBreakpoint'

export default function AccessLevelPage() {
  const { t } = useTranslation()
  const { isSmall } = useBreakpoint()

  return (
    <Box p={isSmall ? 16 : 32}>
      <Box mb="lg">
        <Text style={{ fontFamily: 'Inter, sans-serif', fontSize: isSmall ? 20 : 26, fontWeight: 600, letterSpacing: '-0.3px' }}>
          {t('nav.accessLevels', 'Access Level')}
        </Text>
        <Text size="sm" c="dimmed">
          {t('accessLevel.pageSubtitle', 'Define which pages each access level can see — assign to users under Users management')}
        </Text>
      </Box>
      <AccessLevelTab />
    </Box>
  )
}
